import ProductFilterAppData from '@/models/product-filter-app-data.model';

export default window.productFilterAppData as ProductFilterAppData;